import React, {Component} from "react";
import {Row, Col, Collapse} from 'reactstrap';
import '../Review.css';

export default class ReviewMapDisability extends Component {

    constructor(props) {
       super(props);
       this.state = {
           isMapDisabilityOpened: false
       }
    }

    getDisabilityDisplayValue = (disability) => {
        let mappedDisability = this.props.mapOptions.filter(option => option.label === disability.label);
        if (mappedDisability.length > 0)
            return mappedDisability[0].label;
        else
            return '';
    }

    render() {
        let { allDisabilityMapping } = this.props.mapDisability;
        let {isMapDisabilityOpened} = this.state;
        let noOfDisabilityTypesMapped = allDisabilityMapping.filter(disabilityMapping => disabilityMapping.column!=="").length;
        
        return (<div className="review-sub-section">
            <Row>
                <Col sm="11" md="11" className="review-sub-section-heading">Mapped {noOfDisabilityTypesMapped} of {allDisabilityMapping.length} values to disability categories</Col>
                <Col sm="1" md="1" className={isMapDisabilityOpened ? 'rotate-arrow' : 'text-center'}>
                    <i className={(isMapDisabilityOpened ? 'flaticon-down-arrow ' : 'flaticon-down-arrow').concat(' review-flaticon-down-arrow cursor-pointer')}
                        onClick={() => {
                            this.setState({ isMapDisabilityOpened: !isMapDisabilityOpened });
                        }} />
                </Col>
            </Row>
            <Collapse isOpen={isMapDisabilityOpened}>
                 <div className="mt30 mapped-review-records">
                   {allDisabilityMapping.map((mappedDisability, index) => {
                        return (<div key={index} className={'review-mapped-column '.concat(index === 0 ? ' ' : 'mt10')}>
                            <span style={{ fontWeight: '600' }}>
                            {!mappedDisability.value || mappedDisability.value===undefined||mappedDisability.value===null ||mappedDisability.value==="null"|| mappedDisability.value==="undefined"? 
                                mappedDisability.value="empty"
                                :
                                mappedDisability.value
                                } Disability type
                            </span>
                             {mappedDisability.column!=="" &&mappedDisability.column!==null ? <span><span> mapped to </span>
                            <span style={{ fontWeight: '600' }}>{this.getDisabilityDisplayValue(mappedDisability.column)}</span>
                            </span>: <span> left unmapped</span>}
                        </div>
                        )
                    })}
                </div> 
            </Collapse>
        </div>
                )
    }
}
